/**
 * A common base for all Cesium Ion asset types.
 */
export class CesiumIonAsset {
    constructor(url, token, attributions) {
        this.url = url;
        this.token = token;
        this.tokenHeaderValue = `Bearer ${token}`;
        if (typeof attributions === "undefined") {
            this._attributions = [];
        }
        else {
            this._attributions = attributions;
        }
    }
    /**
     * Returns a list of attributions required by this asset. Library users will need to query this and display the
     * attributions to meet the license requirements of both Cesium Ion and the data we're displaying.
     */
    get attributions() {
        return [...this._attributions];
    }
}
